import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-price-display',
  templateUrl: './price-display.component.html',
  styleUrls: ['./price-display.component.scss'],
})
export class PriceDisplayComponent {
  @Input() label!: string;
  @Input() numLabel: number = 0;
  @Input() price!: number;
  @Input() currency!: any;
  @Input() exchangeRate!: any;
  @Input() userExchangeRate!: any;
  @Input() bookingStatus!: string;
  @Input() deduct: boolean = false;
  @Input() showMarketCurrencyOnly: boolean = true;

  get isOriginalCurrency(): boolean {
    return (
      this.isSameCurrency() 
    );
  }
  isSameCurrency() {
    if (
      this.currency?.currency ===
      this.exchangeRate?.currency_exchange_rate?.toUpperCase()
    ) {
      // if (this.userExchangeRate?.currency_exchange_rate) {
      //   if (
      //     this.userExchangeRate?.currency_exchange_rate?.toUpperCase() ==
      //     this.exchangeRate?.currency_exchange_rate?.toUpperCase()
      //   ) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // } else {
        return true;
      // }
    } else {
      return false;
    }
  }

  transformCurrencyPayment(value: number, showSymbol: boolean = true): any {
    let data = this.exchangeRate;
    if (showSymbol) {
      return (value * data.exchange_rate_value).toLocaleString('en-US', {
        style: 'currency',
        currency: data.currency_exchange_rate,
      });
    } else {
      return (value * data.exchange_rate_value).toLocaleString('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2,
      });
    }
  }
}
